import type { DndEdge } from './types'

export const DRAG_THRESHOLD_PX = 5
export const AUTO_SCROLL_EDGE_PX = 28
export const AUTO_SCROLL_STEP_PX = 14

// Strictly greater than the threshold: a press that never travels is a click.
export function exceedsDragThreshold(startX: number, startY: number, currentX: number, currentY: number, threshold = DRAG_THRESHOLD_PX): boolean {
    return Math.hypot(currentX - startX, currentY - startY) > threshold
}

// One-dimensional scroll decision shared by the window and scroll containers,
// kept pure so the edge math is unit-testable.
export function computeAutoScrollDelta(pointer: number, start: number, end: number, edge = AUTO_SCROLL_EDGE_PX, step = AUTO_SCROLL_STEP_PX): number {
    if (pointer < start + edge) return -step
    if (pointer > end - edge) return step
    return 0
}

/**
 * Vertical insertion edge from pointer Y vs the droppable's midpoint.
 * Above the midpoint → `before`; on or below → `after`.
 * Horizontal / RTL lists are out of scope — use a future 2D helper when needed.
 */
export function computeInsertionEdge(pointerY: number, rect: { top: number; bottom: number }): DndEdge {
    const midpoint = (rect.top + rect.bottom) / 2
    return pointerY < midpoint ? 'before' : 'after'
}
